import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Principal.css';
import CONFIG from '../../config.js';
import { Bar } from 'react-chartjs-2'; // instalar npm install chart.js react-chartjs-2
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { show_alerta } from '../../funciones.js';
import CalendarioResumenEventos from '../mensajes/CalendarioResumenEventos.js';

// Registrar las escalas y elementos de Chart.js
Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const URL_INFO = `${CONFIG.API_URL}/info_principal.php`;
const URL_CALENDARIO = `${CONFIG.API_URL}/operarCalendario.php`;

function PrincipalAdmin({ mensajesSinLeer, rol, configuracion }) {
    const [usuarios, setUsuarios] = useState(0);
    const [cursos, setCursos] = useState(0);
    const [estudiantes, setEstudiantes] = useState(0);
    const [docentes, setDocentes] = useState(0);
    const [matriculaData, setMatriculaData] = useState([]);
    const [matriculaDataI, setMatriculaDataI] = useState([]);
    const [matriculaDataP, setMatriculaDataP] = useState([]);
    const userId =localStorage.getItem('loggedUserId');
    const [eventos, setEventos] = useState([]);
    const fecha = new Date();
    const cicloActual = fecha.getFullYear();

    useEffect(() => {
        buscaInfo();
        obtenerEventos();
    }, []);

    const buscaInfo = () => {
        axios.get(`${URL_INFO}?ciclo=${cicloActual}`)
            .then(res => {
                if (res.data.usuarios) { 
                    setUsuarios(res.data.usuarios);
                    setCursos(res.data.cursos);
                    setEstudiantes(res.data.estudiantes);
                    setDocentes(res.data.docentes);
                    setMatriculaData(res.data.formaciones); // Asumiendo que la API retorna estos datos
                    setMatriculaDataI(res.data.matriculaI); // Asumiendo que la API retorna estos datos
                    setMatriculaDataP(res.data.matriculaP); // Asumiendo que la API retorna estos datos
                    console.log('formaciones:', res.data.formaciones);
                } else {
                    setUsuarios(0);
                    setCursos(0);
                    setEstudiantes(0);
                    setDocentes(0);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const mostrarNombre = (orden)=>{
        let nombre="";
        switch(orden){  
          case "S2":
            nombre='Sala de 2';
            break        
          case "S3":
            nombre='Sala de 3';
          break
          case "S4":
            nombre='Sala de 4';
          break
          case "S5":
            nombre='Sala de 5';
          break
          case "In":
            nombre='Espacio Institucional';
          break
          default:
            nombre=orden+'°';
        }
        return nombre
      };

    // Preparamos los datos para el gráfico para inicial I y para primaria P
    const yearsI = [...new Set(matriculaDataI.map(item => item.año))];
    const yearsP = [...new Set(matriculaDataP.map(item => item.año))];

    const datasetsI = yearsI.map(year => {
        return {
            label: `Inicial ${year}`,
            data: matriculaDataI.filter(item => item.año === year).map(item => item.total_estudiantes),
            backgroundColor: 'rgba(75, 192, 192, 0.6)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
        }
    });
    const datasetsP = yearsP.map(year => {
        return {
            label: `Primaria ${year}`,
            data: matriculaDataP.filter(item => item.año === year).map(item => item.total_estudiantes),
            backgroundColor: 'rgba(202, 14, 8, 0.6)',
            borderColor: 'rgba(241, 41, 41, 1)',
            borderWidth: 1,
        }
    });

    const labelsI = matriculaDataI.map(item => mostrarNombre(item.orden));
    const labelsP = matriculaDataP.map(item => mostrarNombre(item.orden));

    const dataI = {
        labels: labelsI,
        datasets: datasetsI
    };
    const dataP = {
        labels: labelsP,
        datasets: datasetsP
    };

    const obtenerEventos = async () => {
        try {
            const res = await axios.get(URL_CALENDARIO);
            if (Array.isArray(res.data)) {
                // Aplicar filtros según el rol
                const eventosFiltrados = res.data.filter(evento => {
                    const esPropio = evento.creada_por == userId;
    
                let filtroPorRol = false;
                rol = parseInt(rol, 10);
                switch (rol) {
                        case 1:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 2:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 3:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 4:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 5:
                            filtroPorRol = ['todos', 'todosD', 'todosDC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 6:
                            filtroPorRol = ['todos', 'todosD', 'todosDC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 7:
                            filtroPorRol = ['todos', 'todosE', 'todosEC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            //console.log('rol 7, evento:', evento.tipo_recordatorio, 'filtroPorRol:', filtroPorRol);
                            break;
                        case 8:
                            filtroPorRol = ['todos', 'todosT','todosE', 'todoTC', 'todosDETC'].includes(evento.tipo_recordatorio);
                            break;
                        case 9:
                            filtroPorRol = ['todos', 'todosD'].includes(evento.tipo_recordatorio);
                            break;
                        case 12:
                            filtroPorRol = ['todos', 'todosM'].includes(evento.tipo_recordatorio);
                            break;
                        default:
                            filtroPorRol = false;
                            break;
                    }
    
                    return esPropio || filtroPorRol;
                });
    
                setEventos(eventosFiltrados);
            } else {
                setEventos([]);
                console.error('La respuesta de la API no es un array:', res.data);
            }
        } catch (err) {
            console.error('Error al obtener eventos:', err);
        }
    };

    return (    
        <div>
            <h5>Área {rol==2? 'administrador':'equipo directivo'}</h5>
            <div className='row'>
                <div className='col-12 col-md-6 col-lg-4'>
                    <div className='card px-2'>
                        <div className="principal-card" style={{backgroundColor:configuracion.fondo_barra_lateral}}>
                            <div className='principal-caja-circulo-logo' style={{backgroundColor: configuracion.color_secundario, color:configuracion.color_terciario}}><i className='fa-solid fa-envelope'></i></div>
                            <div className='principal-caja-borde-logo'
                                style={{background: configuracion.color_secundario}}>

                            </div>
                            <div className='principal-card-titulo' style={{backgroundColor:configuracion.color_principal, color: configuracion.color_terciario}}>Mensajes sin leer</div>
                            <div className='d-flex justify-content-center principal-texto-info-rojo' style={{color: configuracion.color_principal}}>{mensajesSinLeer}</div>
                        </div>
                        <div className=''>
                            <CalendarioResumenEventos userId={userId} rol={rol} eventos={eventos} />
                        </div>
                                    
                    </div>
                </div>
                <div className='col-12 col-md-6 col-lg-6'>
                    <div className='card px-4 pb-4'>
                        <h2 className='mb-1'>Informe gráfico</h2>
                        {/* armar estadistica de matricula por año y orden */}
                        {matriculaData?.length > 0 && matriculaData.map((formacion) => {
                            if (!formacion.matricula || formacion.matricula.length === 0) return null;

                            const colores = [
                                'rgba(75, 192, 192, 0.6)',
                                'rgba(255, 99, 132, 0.6)',
                                'rgba(54, 162, 235, 0.6)'
                            ];

                            const coloresBorde = [
                                'rgba(75, 192, 192, 1)',
                                'rgba(255, 99, 132, 1)',
                                'rgba(54, 162, 235, 1)'
                            ];
                            // 1. Obtener años únicos (labels)
                            const años = [...new Set(formacion.matricula.map(m => m.año))];
                            // 2. Obtener órdenes únicos (datasets)
                            const ordenes = [...new Set(formacion.matricula.map(m => m.orden))];
                            // 3. Armar datasets
                            const datasets = ordenes.map((orden, index) => ({
                                label: `Año ${orden}`,
                                data: años.map(año => {
                                    const item = formacion.matricula.find(
                                        m => m.año === año && m.orden === orden
                                    );
                                    return item ? Number(item.total_estudiantes) : 0;
                                }),
                                backgroundColor: colores[index % colores.length]
                            }));
                            const chartData = {
                                labels: años,
                                datasets
                            };
                            return (
                                <div key={formacion.id_formacion}>
                                    <h5 className='mt-2'>{formacion.nombre_formacion} - nivel: {formacion.nivel}</h5>
                                    <div className='principal-grafico'>
                                        <Bar data={chartData} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                   
                </div>
                <div className='col-12 col-md-12 col-lg-2 card'>
                <div className='row'>
                    <div className='col-6 col-md-3 col-lg-12 d-flex justify-content-center'>
                        <div className='cuadro-info-simple ' style={{
                            background:configuracion.color_secundario,
                            background: `linear-gradient(266deg,${configuracion.color_secundario} 0%, ${configuracion.color_principal} 100%, ${configuracion.color_terciario} 100%)`}}
                        >
                            <i className='fa-solid fa-users'></i>
                            <div className='texto-info1' style={{color:configuracion.color_terciario}}>{usuarios} Usuarios</div>
                        </div>
                    </div>
                    <div className='col-6 col-md-3 col-lg-12 d-flex justify-content-center'>
                        <div className='cuadro-info-simple'  style={{
                            background:configuracion.color_secundario,
                            background: `linear-gradient(266deg,${configuracion.color_principal} 0%, ${configuracion.color_secundario} 100%, ${configuracion.color_terciario} 100%)`}}>
                            <i className="fa-solid fa-boxes-stacked"></i>
                            <div className='texto-info1' style={{color:configuracion.color_terciario}}>{cursos} cursos</div>
                        </div>
                    </div>
                    <div className='col-6 col-md-3 col-lg-12 d-flex justify-content-center'>
                        <div className='cuadro-info-simple ' style={{
                            background:configuracion.color_secundario,
                            background: `linear-gradient(266deg,${configuracion.color_secundario} 0%, ${configuracion.color_principal} 100%, ${configuracion.color_terciario} 100%)`}}
                        >    
                            <i className="fa-solid fa-graduation-cap"></i>
                            <div className='texto-info1' style={{color:configuracion.color_terciario}}>{estudiantes} estudiantes</div>
                        </div>
                    </div>
                    <div className='col-6 col-md-3 col-lg-12 d-flex justify-content-center'>
                        <div className='cuadro-info-simple' style={{
                            background:configuracion.color_secundario,
                            background: `linear-gradient(266deg,${configuracion.color_principal} 0%, ${configuracion.color_secundario} 100%, ${configuracion.color_terciario} 100%)`}}> 
                            <i className="fa-solid fa-chalkboard-user"></i>
                            <div className='texto-info1' style={{color:configuracion.color_terciario}}>{docentes} Docentes</div>
                        </div>                        
                    </div>
                </div>
 
                </div>
            </div>
        </div>
    );
}

export default PrincipalAdmin;
